import React from "react";
import "./styles.scss";
import Tooltip from "@material-ui/core/Tooltip";
import { BiInfoCircle } from "react-icons/bi";
import { useTranslation } from "react-i18next";

interface IProps {
  value: number;
  label: string;
  onSetQnt: (value: number) => void;
}

const BirthDayQnt: React.FC<IProps> = ({ label, value, onSetQnt }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={"form-qnt-button"}>
      <div className="flex-start-center">
        <b className={"label"}>{label}</b>
        <Tooltip className="tooltip" placement="right" title={t("ustaw_liczbe_osob_wliczajac_opiekunow")}>
          <b>
            <BiInfoCircle className="tooltip-icon" />
          </b>
        </Tooltip>
      </div>

      <div className={"qnt-wrapper"}>
        {value === 1 ? (
          <button
            className={"button medium padding-small button-fill-background-main"}
            onClick={() => onSetQnt(value > 1 ? value - 1 : value)}
          >
            -
          </button>
        ) : (
          <button
            className={"button medium padding-small button-fill-main"}
            onClick={() => onSetQnt(value > 1 ? value - 1 : value)}
          >
            -
          </button>
        )}

        <b className={"value"}>{value}</b>
        <button className={"button medium padding-small button-fill-main"} onClick={() => onSetQnt(value + 1)}>
          +
        </button>
      </div>
    </div>
  );
};

export default BirthDayQnt;
